import { Box } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import React from 'react';
import { PopUpNotification } from '../notifications/pop-up-notification';
export const ScanCompletedNotification = _ref => {
  let {
    onClose
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Box, {
    bottom: "40px",
    position: "absolute",
    zIndex: 10
  }, /*#__PURE__*/React.createElement(PopUpNotification, {
    message: t('accessibility-wizard.footer.scan-completed'),
    skin: "experimentalDark",
    onClose: () => onClose(false)
  }));
};
//# sourceMappingURL=scan-completed-notification.js.map